// extracted by mini-css-extract-plugin
export var cellWithIconWrapper = "c7177dc546f6ed469e87483054ee8e60-css";
export var cellIcon = "_3f0352a3e54e36e0c6d1a6969eb3a93e-css";